import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import axios from 'axios'
import { DisplayStatusComponent } from './utils'
import { DisplayHtmlComponent } from '../AOHtml'

export const AOReadMatchHtmlComponent = () => {
    const { key } = useParams();
    const [aoHtml, setAoHtml] = useState();

    useEffect(() => {
        if (!key) {
            return;
        }

        axios.get('/api/aoreadondemand/aohtml?key=' + key).then(response => {
            if (response.data) {
                setAoHtml(response.data);
            }
        })

    }, [key]);

    if (!key) {
        return <></>
    }


    var aoResult = <></>
    if (aoHtml) {
        aoResult = <><DisplayHtmlComponent html={aoHtml} /></>
    }

    return <div><DisplayStatusComponent calculKey={key} checkStatus={() => true} errorMessageCheckStatus={"L'appel d'offre n'a pas pu être parsé"} /> {aoResult} </div>

}





